import { render, staticRenderFns } from "./Manage-Position.vue?vue&type=template&id=091f5af7"
import script from "./Manage-Position.vue?vue&type=script&lang=js"
export * from "./Manage-Position.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports